import React from 'react';
import { Box, Typography } from '@mui/material';
import { Build as MaintenanceIcon } from '@mui/icons-material';
import NotificationDialog from './NotificationDialog';

const MaintenanceUpcomingNotice = ({
  open,
  warning,
  onClose,
}) => {
  if (!warning) return null;

  const { maintenance, leadTimeLabel, startsAtLabel } = warning;
  const title = maintenance?.title || 'Scheduled maintenance';

  return (
    <NotificationDialog
      open={open}
      onClose={onClose}
      title={`Maintenance in about ${leadTimeLabel}`}
      iconPreset="warning"
      icon={<MaintenanceIcon sx={{ color: 'warning.main', fontSize: 28 }} aria-hidden />}
      buttons={['dismiss']}
      buttonLabels={{ dismiss: 'OK' }}
    >
      <Box>
        <Typography variant="body1" color="text.secondary" sx={{ fontWeight: 600, mb: 0.5 }}>
          {title}
        </Typography>
        {maintenance?.description ? (
          <Typography variant="body2" color="text.secondary" sx={{ mb: 0.5 }}>
            {maintenance.description}
          </Typography>
        ) : null}
        <Typography variant="caption" color="text.secondary" sx={{ display: 'block' }}>
          Expected start: {startsAtLabel}
        </Typography>
      </Box>
    </NotificationDialog>
  );
};

export default MaintenanceUpcomingNotice;
